import { useLocation, useSearchParams } from 'react-router'
import classnames from 'classnames'

import { EMPTY_LIST } from '../../constants/common'
import { SUBMENU_PARAM_KEY } from '../../constants/route'
import { useHasSubMenuItems, useMenuCollapsedState } from '../../hooks'
import { getMenuActiveItem } from '../../utils/menu'

import { SUB_MENU_COMPONENT } from './Menu.constants'
import { MenuLogo } from './MenuLogo'
import { PrimaryMenu } from './PrimaryMenu'
import { SecondaryMenu } from './SecondaryMenu'

import * as styles from './Menu.module.css'

function Menu({
  LogoLink,
  className = styles.Menu,
  contentClassName = styles.content,
  items = EMPTY_LIST,
}) {
  const { pathname } = useLocation()

  const [collapsed] = useMenuCollapsedState()

  const [searchParams] = useSearchParams()

  const activeItem = getMenuActiveItem(items, pathname)

  const hasSubMenu = useHasSubMenuItems()

  // email sub menu has logic needed for loading list page and we need render sub menu without sub menu items from store
  const withSubMenu =
    (hasSubMenu && searchParams.get(SUBMENU_PARAM_KEY) != null) ||
    !!SUB_MENU_COMPONENT[activeItem?.to]

  const menuClassName = classnames(className, {
    [styles.collapsed]: collapsed,
    [styles.expanded]: !collapsed,
  })

  return (
    <div className={menuClassName} data-section='MenuSection'>
      <MenuLogo Link={LogoLink} className={styles.logo} collapsed={collapsed} />
      <div className={contentClassName}>
        <PrimaryMenu
          className={styles.primary}
          collapsed={collapsed || withSubMenu}
          items={items}
        />
        {withSubMenu ? (
          <SecondaryMenu
            Component={SUB_MENU_COMPONENT[activeItem?.to]}
            activeItem={activeItem}
            className={styles.secondary}
            items={items}
          />
        ) : null}
      </div>
    </div>
  )
}

export default Menu
